<template>
  <div class="bo-selector bo--selector-store">
    <i class="fas fa-building" />
    <MultiSelect
        aria-autocomplete="none"
        class="bo-fullwidth" style="z-index: 10000"
        :options="globalState.getters.availableEntities"
        optionLabel="name"
        placeholder="Entity"
        optionValue="id"
        v-model="selectedEntities"
    >
    </MultiSelect>
  </div>
</template>
<script>
import {computed, defineComponent, onMounted, reactive, watch} from "vue";
import {globalState} from '@/states/global';
import {authState} from '@/states/auth';
export default defineComponent({
  setup() {

    const selectedEntities = computed({
      get: () => globalState.state.selected.entityIds,
      set: (v) => { globalState.dispatch('setEntityIds', v); }
    });

    return {
      globalState,
      selectedEntities
    }
  }
})
</script>

<!-- <template>


  <!- Entities : {{ selectedEntities.value }}
</template>

<script>
import EntityProvider from "@/providers/entityprovider";
import { defineComponent, onMounted, reactive, watch } from "vue";
 import { globalState } from '@/states/global';
import { authState } from '@/states/auth';

export default defineComponent({
  setup() {
    const entities = reactive([]);

    const selectedEntities = reactive([]);

    watch(
      () => selectedEntities.value,
      (newVal, oldVal) => {
        globalState.dispatch("setEntityIds", newVal);
      }
    );

    const refreshEntities = async () => {
      entities.value = await new EntityProvider().fetchEntities();
      selectedEntities.value = entities.value.map((x) => x.id);
    };

    watch(
      () => authState.state.globalUser,
      async (newVal, oldVal) => {
        await refreshEntities();
      }
    );

    onMounted(async () => {
      await refreshEntities();
    });

    return {
      entities,
      selectedEntities,
    };
  },
});
</script> -->
